window.initRetailerLocator = function initRetailerLocator() {
  // called in retailer-locator.liquid in the googleapis script
  // Assigning directly to window.initRetailerLocator guarantees Google can call it regardless of how the script is loaded.
  const mapElement = document.getElementById('retailerLocatorMap');
  const listElement = document.getElementById('retailerLocatorList');

  if (mapElement) {
    viewModeToggle(mapElement);
    retailerMap(mapElement);
    retailerList(listElement);
  }
};

function viewModeToggle(mapElement) {
  let announcer = document.querySelector("#retailerLocatorAnnouncer");
  let mapButton = document.querySelector("#retailerModeToggleMap");
  let listButton = document.querySelector("#retailerModeToggleList");

  if (listButton && mapButton) {
    listButton.addEventListener('click', function () {
      announcer.textContent = "Locator is now in list mode.";

      listButton.classList.toggle('mci-retailer-mode-toggle--active');
      mapButton.classList.toggle('mci-retailer-mode-toggle--active');

      mapElement.parentElement.classList.add('mci-retailer-locator--list');
      mapElement.parentElement.classList.remove('mci-retailer-locator--map');
    });

    mapButton.addEventListener('click', function () {
      announcer.textContent = "Locator is now in map mode.";

      mapButton.classList.toggle('mci-retailer-mode-toggle--active');
      listButton.classList.toggle('mci-retailer-mode-toggle--active');

      mapElement.parentElement.classList.add('mci-retailer-locator--map');
      mapElement.parentElement.classList.remove('mci-retailer-locator--list');
    });
  }
}

function retailerMap(mapElement) {

  if (mapElement) {
    // Create the map.
    const map = new google.maps.Map(mapElement, {
      zoom: 5,
      center: { lat: 49.90756902827486, lng: -97.17522251074536 },
      gestureHandling: 'cooperative',
      disableDefaultUI: true,
      zoomControl: true,
      mapId: 'e1cad166851dbc8291107221',
    });

    // Load the stores GeoJSON onto the map.
    map.data.loadGeoJson('https://cdn.shopify.com/s/files/1/2790/0342/files/retailer-locator-stores.json?v=1772135368', { idPropertyName: 'storeid' });

    // Define the custom marker icon
    map.data.setStyle((feature) => {
      return {
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: '#7F6C62',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
        },
      };
    });

    const infoWindow = new google.maps.InfoWindow();

    // Show the information for a store when its marker is clicked.
    map.data.addListener('click', (event) => {
      const name = event.feature.getProperty('name');
      const address = event.feature.getProperty('address');
      const position = event.feature.getGeometry().get();
      const content = `
        <h2>${name}</h2>
        <address>${address}</address>
      `;

      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
      infoWindow.open(map);
    });

    // Build and add the search bar
    const card = document.createElement('div');
    const container = document.createElement('div');

    card.classList.add('rl-search');

    const autocomplete = new google.maps.places.PlaceAutocompleteElement({
      includedRegionCodes: ['us', 'ca'],
      includedPrimaryTypes: ['neighborhood', 'postal_code_prefix', 'street_address', 'sublocality', 'locality']
    });
    autocomplete.classList.add('rl-search__input');

    container.appendChild(autocomplete);
    card.appendChild(container);
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    // Set the origin point when the user selects an address
    // AdvancedMarkerElement has no setVisible() — control visibility via .map instead
    const originMarker = new google.maps.marker.AdvancedMarkerElement();
    let originLocation = map.getCenter();

    autocomplete.addEventListener('gmp-select', async (event) => {
      const place = event.placePrediction.toPlace();
      await place.fetchFields({ fields: ['location', 'displayName'] });

      originLocation = place.location;
      map.setCenter(originLocation);
      map.setZoom(9);

      originMarker.position = originLocation;
      originMarker.map = map;

      await calculateDistances(map.data, originLocation);
    });

    function haversineDistance(origin, destination) {
      const R = 6371000;
      const toRad = (x) => (x * Math.PI) / 180;

      const lat1 = toRad(origin.lat());
      const lat2 = toRad(destination.lat());
      const dLat = toRad(destination.lat() - origin.lat());
      const dLng = toRad(destination.lng() - origin.lng());

      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;

      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    async function calculateDistances(data, origin) {
      const stores = [];

      data.forEach((store) => {
        const dest = store.getGeometry().get();
        const distanceVal = haversineDistance(origin, dest);
        stores.push({
          storeid: store.getProperty('storeid'),
          distanceVal,
          distanceText: (distanceVal / 1000).toFixed(1) + ' km',
        });
      });

      stores.sort((a, b) => a.distanceVal - b.distanceVal);

      showStoresList(map.data, stores.slice(0, 15), true);

      return stores;
    }

    function showStoresList(data, stores, focusFirst = false) {
      if (stores.length == 0) {
        console.log('empty stores');
        return;
      }

      let panel = document.createElement('ul');
      panel.ariaLabel = 'List of nearby stores';
      // If the panel already exists, use it. Else, create it and add to the page.
      if (document.getElementById('panel')) {
        panel = document.getElementById('panel');
        // If panel is already open, close it
        if (panel.classList.contains('open')) {
          panel.classList.remove('open');
        }
      } else {
        panel.setAttribute('id', 'panel');
        const siblingElement = document.getElementById('retailerLocatorMap');
        siblingElement.insertAdjacentElement('beforeend', panel);
      }

      // Clear the previous details
      while (panel.lastChild) {
        panel.removeChild(panel.lastChild);
      }

      stores.forEach((store) => {
        const currentStore = data.getFeatureById(store.storeid);

        // Wrap each store in a clickable listing div
        const listing = document.createElement('li');
        listing.classList.add('listing');

        // Add store details with text formatting
        const name = document.createElement('p');
        name.classList.add('listing__place');
        name.textContent = currentStore.getProperty('name');
        // address
        const address = document.createElement('p');
        address.classList.add('listing__address');
        address.textContent = currentStore.getProperty('address');
        // distance
        const distanceText = document.createElement('p');
        distanceText.classList.add('listing__distance-text');
        distanceText.textContent = store.distanceText;
        // button
        const button = document.createElement('button');
        button.classList.add('listing__button');
        button.textContent = 'View on Map';
        button.ariaLabel = `View on Map - ${currentStore.getProperty('name')}`;
        // append
        listing.appendChild(name);
        listing.appendChild(address);
        listing.appendChild(distanceText);
        listing.appendChild(button);

        // Click handler — pans map and opens the info window for this store
        button.addEventListener('click', () => {
          const position = currentStore.getGeometry().get();

          map.panTo(position);
          map.setZoom(13);

          infoWindow.setContent(`
            <div>
              <h2>${currentStore.getProperty('name')}</h2>
              <p>${currentStore.getProperty('address')}</p>
            </div>
          `);
          infoWindow.setPosition(position);
          infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
          infoWindow.open(map);

          // Highlight the active listing
          document.querySelectorAll('#panel .listing').forEach(el => el.classList.remove('active'));
          listing.classList.add('active');
        });

        // append all listings to panel
        panel.appendChild(listing);
      });

      // Open the panel
      panel.classList.add('open');

      if (focusFirst) {
        const firstListing = panel.querySelector('.listing');
        if (firstListing) {
          firstListing.setAttribute('tabindex', '-1');
          firstListing.focus();
        }
      }

      return;
    }
  }
}

function retailerList(listElement) {
  if (listElement) {
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://cdn.shopify.com/s/files/1/2790/0342/files/retailer-locator-stores-list.json');
      xhr.responseType = 'json';
      xhr.onload = () => xhr.status === 200
        ? resolve(xhr.response)
        : reject(new Error('Failed to load store data: ' + xhr.status));
      xhr.onerror = () => reject(new Error('Network error loading store data'));
      xhr.send();
    })
      .then(STORES => {

        // ── State ──
        let filtered = [...STORES];

        const countryNames = { CA: 'Canada', US: 'United States' };
        const stateNames = {
          AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador',
          NS: 'Nova Scotia', NT: 'Northwest Territories', ON: 'Ontario', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon',
          AK: 'Alaska', AL: 'Alabama', AZ: 'Arizona', CA: 'California', CO: 'Colorado', CT: 'Connecticut', FL: 'Florida',
          GA: 'Georgia', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
          MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri', MS: 'Mississippi', MT: 'Montana',
          NC: 'North Carolina', ND: 'North Dakota', NE: 'Nebraska', NJ: 'New Jersey', NV: 'Nevada', NY: 'New York',
          OH: 'Ohio', OK: 'Oklahoma', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia', WA: 'Washington', WI: 'Wisconsin'
        };

        // ── DOM refs ──
        const countrySelect = document.getElementById('country-select');
        const stateSelect = document.getElementById('state-select');
        const citySelect = document.getElementById('city-select');
        const clearBtn = document.getElementById('clear-btn');
        const storeList = document.getElementById('store-list');
        const resultsSummary = document.getElementById('results-summary');
        const liveRegion = document.getElementById('retailerLocatorAnnouncer');

        // ── Populate state dropdown based on country ──
        function populateStates(country) {
          const existing = stateSelect.value;
          stateSelect.innerHTML = '<option value="">All Provinces &amp; States</option>';

          const states = [...new Set(
            STORES
              .filter(s => !country || s.country === country)
              .map(s => s.state)
              .filter(Boolean)
          )].sort();

          states.forEach(code => {
            const opt = document.createElement('option');
            opt.value = code;
            opt.textContent = stateNames[code] ? `${stateNames[code]} (${code})` : code;
            stateSelect.appendChild(opt);
          });

          stateSelect.value = states.includes(existing) ? existing : '';
        }

        // ── Populate city dropdown based on country + state ──
        function populateCities(country, state) {
          const existing = citySelect.value;
          citySelect.innerHTML = '<option value="">All Cities</option>';

          const cities = [...new Set(
            STORES
              .filter(s => (!country || s.country === country) && (!state || s.state === state))
              .map(s => s.city)
              .filter(Boolean)
          )].sort();

          cities.forEach(city => {
            const opt = document.createElement('option');
            opt.value = city;
            opt.textContent = city;
            citySelect.appendChild(opt);
          });

          citySelect.value = cities.includes(existing) ? existing : '';
        }

        // ── Format full address ──
        function formatAddress(store) {
          const parts = [store.address, store.city, store.state, store.postal, store.country].filter(Boolean);
          return parts.join(', ');
        }

        // ── Render stores ──
        function renderStores() {
          const country = countrySelect.value;
          const state = stateSelect.value;
          const city = citySelect.value;

          filtered = STORES.filter(s => {
            if (country && s.country !== country) return false;
            if (state && s.state !== state) return false;
            if (city && s.city !== city) return false;
            return true;
          });

          storeList.innerHTML = '';

          if (filtered.length === 0) {
            storeList.innerHTML = `
          <li class="empty-state" role="status">
            <p>No stores found</p>
            <p>Try adjusting your filters or search term.</p>
          </li>`;
            resultsSummary.textContent = 'No stores found.';
            announce('No stores found. Try adjusting your filters.');
            return;
          }

          const fragment = document.createDocumentFragment();
          filtered.forEach((store) => {
            const li = document.createElement('li');
            li.className = 'store-card';

            const fullAddr = formatAddress(store);

            li.innerHTML = `
          <div>
            <p class="store-name">${escapeHtml(store.name)}</p>
            <address class="store-address">
              ${escapeHtml(store.address)}${store.city ? '<br>' + escapeHtml(store.city) : ''}${store.state ? ', ' + escapeHtml(store.state) : ''}${store.postal ? ' ' + escapeHtml(store.postal) : ''}
            </address>
          </div>
          <button
            class="copy-btn"
            type="button"
            aria-label="Copy address for ${escapeHtml(store.name)}"
            data-addr="${escapeHtml(fullAddr)}"
            data-store="${escapeHtml(store.name)}"
          >Copy address</button>
        `;

            fragment.appendChild(li);
          });

          storeList.appendChild(fragment);

          // Bind copy buttons
          storeList.querySelectorAll('.copy-btn').forEach(btn => {
            btn.addEventListener('click', handleCopy);
          });

          // Update visible count
          const summary = `Showing ${filtered.length} of ${STORES.length} stores`;
          resultsSummary.textContent = summary;
        }

        // ── Copy address ──
        function handleCopy(e) {
          const btn = e.currentTarget;
          const addr = btn.dataset.addr;
          const storeName = btn.dataset.store;

          navigator.clipboard.writeText(addr).then(() => {
            btn.textContent = 'Copied!';
            btn.classList.add('copied');
            btn.setAttribute('aria-label', `Address copied for ${storeName}`);
            announce(`Address copied for ${storeName}: ${addr}`);
            setTimeout(() => {
              btn.textContent = 'Copy address';
              btn.classList.remove('copied');
              btn.setAttribute('aria-label', `Copy address for ${storeName}`);
            }, 2000);
          }).catch(() => {
            // Fallback
            const ta = document.createElement('textarea');
            ta.value = addr;
            ta.style.position = 'fixed'; ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            btn.textContent = 'Copied!';
            btn.classList.add('copied');
            announce(`Address copied for ${storeName}`);
            setTimeout(() => { btn.textContent = 'Copy address'; btn.classList.remove('copied'); }, 2000);
          });
        }

        // ── Announce to screen readers ──
        let announceTimer;
        function announce(msg) {
          clearTimeout(announceTimer);
          liveRegion.textContent = '';
          announceTimer = setTimeout(() => { liveRegion.textContent = msg; }, 100);
        }

        // ── Escape HTML ──
        function escapeHtml(str) {
          if (!str) return '';
          return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }

        // ── Event listeners ──
        countrySelect.addEventListener('change', () => {
          populateStates(countrySelect.value);
          populateCities(countrySelect.value, '');
          renderStores();
        });

        stateSelect.addEventListener('change', () => {
          populateCities(countrySelect.value, stateSelect.value);
          renderStores();
        });

        citySelect.addEventListener('change', renderStores);

        clearBtn.addEventListener('click', () => {
          countrySelect.value = '';
          populateStates('');
          populateCities('', '');
          stateSelect.value = '';
          citySelect.value = '';
          renderStores();
          announce('All filters cleared');
        });

        // ── Init ──
        populateStates('');
        populateCities('', '');
        renderStores();

      })
      .catch(err => {
        console.error('Retailer list error:', err);
      });
  }
}